
import { defineComponent } from 'vue'

import Tabs from '@/common/components/UI/Tabs/index.vue'

// types
import { TabT } from '@/core/types/components.types'

export default defineComponent({
    components: {
        tabs: Tabs,
    },
    setup() {
        const tabs: TabT[] = [
            { id: 1, name: 'LTL', path: '/order/create' },
            { id: 2, name: 'FTL', path: '/order/create/ftl' },
            { id: 3, name: 'Доставка за 3 часа', path: '/order/create/express' },
            { id: 4, name: 'Spark.kz', path: '/order/create/spark' },
        ]

        return { tabs }
    },
})
